import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ServicesPage = () => {
  return (
    <div>
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-deep-blue">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-deep-blue to-black opacity-70"></div>
          {/* This would be replaced with an actual image in production */}
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581093458791-9d09a5c0d6e5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
        </div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl font-montserrat">
            OUR SERVICES
          </h1>
          <p className="mt-6 text-xl text-white max-w-3xl font-roboto">
            Comprehensive Automotive Electronics Solutions
          </p>
        </div>
      </div>
      
      {/* Services Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-deep-blue font-montserrat">COMPREHENSIVE SOLUTIONS</h2>
            <p className="mt-4 text-lg text-charcoal max-w-3xl mx-auto">
              At Protec Services and Distribution, we provide end-to-end solutions for automotive monitors and interior electronics, from assembly to global distribution.
            </p>
          </div>
        </div>
      </section>
      
      {/* Assembly Service */}
      <section id="assembly" className="py-16 bg-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-1/2 lg:pr-12 mb-8 lg:mb-0">
              <h2 className="text-3xl font-bold text-deep-blue font-montserrat mb-6">Assembly</h2>
              <p className="text-lg text-charcoal mb-4">
                Our precision assembly services for automotive monitors and interior electronics components ensure the highest quality and reliability. Our state-of-the-art facilities and expert technicians handle everything from simple component assembly to complex electronic systems.
              </p>
              <p className="text-lg text-charcoal mb-4">
                We employ advanced assembly techniques and follow strict quality control protocols to ensure that every product meets or exceeds industry standards.
              </p>
              <ul className="list-disc pl-5 text-charcoal mb-4">
                <li className="mb-2">Automotive monitor assembly</li>
                <li className="mb-2">Interior electronics components</li>
                <li className="mb-2">Control panel assembly</li>
                <li className="mb-2">Circuit board population</li>
                <li className="mb-2">Final product integration</li>
              </ul>
            </div>
            <div className="lg:w-1/2">
              {/* This would be replaced with an actual image in production */}
              <div className="bg-white h-80 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1581093458791-9d09a5c0d6e5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Inspection Service */}
      <section id="inspection" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center">
            <div className="lg:w-1/2 lg:pl-12 mb-8 lg:mb-0">
              <h2 className="text-3xl font-bold text-deep-blue font-montserrat mb-6">Inspection</h2>
              <p className="text-lg text-charcoal mb-4">
                Quality is at the heart of everything we do. Our comprehensive inspection services ensure that every component and assembled unit meets rigorous quality standards before leaving our facility.
              </p>
              <p className="text-lg text-charcoal mb-4">
                We utilize advanced testing equipment and methodologies to verify functionality, durability, and compliance with industry specifications.
              </p>
              <ul className="list-disc pl-5 text-charcoal mb-4">
                <li className="mb-2">Visual inspection</li>
                <li className="mb-2">Functional testing</li>
                <li className="mb-2">Environmental stress screening</li>
                <li className="mb-2">Quality assurance certification</li>
                <li className="mb-2">Performance validation</li>
              </ul>
            </div>
            <div className="lg:w-1/2">
              {/* This would be replaced with an actual image in production */}
              <div className="bg-light-gray h-80 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Parts Consolidation Service */}
      <section id="consolidation" className="py-16 bg-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-1/2 lg:pr-12 mb-8 lg:mb-0">
              <h2 className="text-3xl font-bold text-deep-blue font-montserrat mb-6">Parts Consolidation</h2>
              <p className="text-lg text-charcoal mb-4">
                Our parts consolidation services streamline the supply chain by bringing together components from various suppliers into a single, efficient process. This reduces complexity and costs while ensuring consistent quality.
              </p>
              <p className="text-lg text-charcoal mb-4">
                We manage inventory, coordinate with multiple suppliers, and ensure that all necessary components are available for assembly when needed.
              </p>
              <ul className="list-disc pl-5 text-charcoal mb-4">
                <li className="mb-2">Supplier coordination</li>
                <li className="mb-2">Inventory management</li>
                <li className="mb-2">Component sourcing</li>
                <li className="mb-2">Quality control of incoming parts</li>
                <li className="mb-2">Just-in-time delivery</li>
              </ul>
            </div>
            <div className="lg:w-1/2">
              {/* This would be replaced with an actual image in production */}
              <div className="bg-white h-80 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1581093458896-c9dc541d7dc4?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Distribution Service */}
      <section id="distribution" className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center">
            <div className="lg:w-1/2 lg:pl-12 mb-8 lg:mb-0">
              <h2 className="text-3xl font-bold text-deep-blue font-montserrat mb-6">Distribution</h2>
              <p className="text-lg text-charcoal mb-4">
                Our global distribution network ensures that your products reach their destination efficiently and on time. We handle logistics, shipping, and delivery to manufacturers and suppliers worldwide.
              </p>
              <p className="text-lg text-charcoal mb-4">
                With strategic partnerships and optimized shipping routes, we provide reliable distribution services that support your supply chain needs.
              </p>
              <ul className="list-disc pl-5 text-charcoal mb-4">
                <li className="mb-2">Global shipping capabilities</li>
                <li className="mb-2">Logistics management</li>
                <li className="mb-2">Customs documentation</li>
                <li className="mb-2">Tracking and reporting</li>
                <li className="mb-2">On-time delivery guarantees</li>
              </ul>
            </div>
            <div className="lg:w-1/2">
              {/* This would be replaced with an actual image in production */}
              <div className="bg-light-gray h-80 rounded-lg shadow-md bg-[url('https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Process Flow */}
      <section className="py-16 bg-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-deep-blue font-montserrat">OUR PROCESS</h2>
            <p className="mt-4 text-lg text-charcoal max-w-3xl mx-auto">
              A streamlined approach from parts acquisition to final delivery
            </p>
          </div>
          
          <div className="relative">
            {/* Process Steps */}
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-deep-blue transform -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="relative">
                <div className="md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 bg-deep-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold z-10 mx-auto md:mx-0">
                  1
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center mt-6 md:mt-0">
                  <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Parts Acquisition</h3>
                  <p className="text-charcoal">Sourcing and consolidating quality components from trusted suppliers</p>
                </div>
              </div>
              
              <div className="relative">
                <div className="md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 bg-deep-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold z-10 mx-auto md:mx-0">
                  2
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center mt-6 md:mt-0">
                  <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Assembly</h3>
                  <p className="text-charcoal">Precision assembly of monitors and electronics by skilled technicians</p>
                </div>
              </div>
              
              <div className="relative">
                <div className="md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 bg-deep-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold z-10 mx-auto md:mx-0">
                  3
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center mt-6 md:mt-0">
                  <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Quality Control</h3>
                  <p className="text-charcoal">Rigorous testing and inspection to ensure performance and reliability</p>
                </div>
              </div>
              
              <div className="relative">
                <div className="md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2 bg-deep-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold z-10 mx-auto md:mx-0">
                  4
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md text-center mt-6 md:mt-0">
                  <h3 className="text-xl font-semibold mb-2 font-montserrat text-deep-blue">Distribution</h3>
                  <p className="text-charcoal">Global delivery network ensuring timely arrival at destination</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Call to Action */}
      <section className="py-16 bg-deep-blue text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold font-montserrat mb-4">NEED CUSTOM SOLUTIONS?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Contact us to discuss your specific requirements
          </p>
          <a
            href="/contact"
            className="inline-block bg-light-blue hover:bg-blue-700 text-white font-montserrat font-semibold uppercase tracking-wider py-3 px-8 border border-transparent rounded-md shadow-md transition duration-300"
          >
            CONTACT US
          </a>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default ServicesPage;
